module.exports = __webpack_public_path__ + "5f3a10b7863e0f4bed087cfaf8eec5af.ttf";